import { HelpIcon } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import type { WrappedFieldProps } from 'redux-form';

type SelectFieldProps = {
  name: string | null;
  displayName: string | null;
  disabled: boolean | null;
  hidden: boolean | null;
  style?: any;
  required: boolean | null;
  placeholder: string | null;
  children: any;
  className: string | null;
  showHelpIcon: boolean | null;
  helpIconTitle: string;
  helpIconText: string;
  onChangeAction: ((e: any) => void) | null;
  isInline: boolean;
} & WrappedFieldProps;

const SelectField = ({
  name,
  displayName,
  style,
  placeholder,
  hidden,
  disabled,
  required,
  input,
  meta,
  onChangeAction,
  className,
  showHelpIcon,
  helpIconTitle,
  helpIconText,
  children,
  isInline,
}: SelectFieldProps): JSX.Element => {
  let validationErrors: JSX.Element | null = null;
  let helpIcon: JSX.Element | null = null;

  const hasSuccess = meta.touched && meta.valid && meta.dirty;
  const hasError = meta.touched && meta.error;
  const isHidden = !!hidden;
  const isDisabled = !!disabled;
  const isRequired = !!required;
  const inputName = name || input.name || '';

  const formGroupClasses = classnames(
    {
      'form-group-select': true,
      'has-success': hasSuccess,
      'has-error': !hasSuccess && hasError,
      'form-group': !isInline,
      'form-group-inline': isInline,
      focused: meta && meta.active,
      active: isHidden,
      disabled: isDisabled,
    },
    className || '',
  );

  if (!hasSuccess && hasError) {
    validationErrors = <span className="validation-text">{meta.error}</span>;
  }

  if (placeholder === null || placeholder === undefined) {
    placeholder = (name ? name : '') + '...';
  }

  if (showHelpIcon) {
    helpIcon = (
      <span className="helpIcon">
        <HelpIcon text={helpIconText} title={helpIconTitle} />
      </span>
    );
  }

  return (
    <div className={formGroupClasses} style={style}>
      <label className="control-label" htmlFor={inputName}>
        {displayName ? displayName : ''} {required ? '*' : ''}{' '}
        {validationErrors}
      </label>
      {helpIcon}
      <select
        value={input.value}
        onBlur={input.onBlur}
        onFocus={input.onFocus}
        onChange={(e) => {
          if (typeof onChangeAction === 'function') {
            onChangeAction(e.target.value);
          }
          input.onChange(e);
        }}
        required={isRequired}
        id={inputName}
        disabled={isDisabled}
        className="form-control"
      >
        {children}
      </select>
    </div>
  );
};

SelectField.defaultProps = {
  disabled: false,
  hidden: false,
  required: false,
  showError: false,
  isInline: false,
};

export default SelectField;
